// extracted by mini-css-extract-plugin
export default {"root":"NotFound_root__uv3FM","content":"NotFound_content__4Agfe","subtitle":"NotFound_subtitle__iXk7W","green":"NotFound_green__86von","actions":"NotFound_actions__OjeuF"};